export const appConfigDetails = {
  appUrls: {
    FlexiChecklistManager: "/flexichecklist/manager",
    FlexiTemplateBuilder: "/flexichecklist/builder",
    FlexiChecklist: "/flexiportal",
    ShiftLogBook: "/shiftlogbook",
    Photos: "/photosweb",
    "FlexiChecklist-Mechanical": "/fleximechportal",
    "Failsafe-Logbook": "/failsafe",
    "FlexiChecklist-Electrical": "/flexiet ",
    "Lesson-Learned":
      "https://apex.oci.siemens-energy.com/ark/f?p=30340:26:14775072765661",
  },
  mobileApps: {
    Flexi: false,
    ShiftLogBook: false,
    FQP: true,
    LOP: true,
    Photos: false,
    "Quality Inspection": true,
    Piping: true,
  },
};
